<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="51.579"
    height="51.578"
    viewBox="0 0 51.579 51.578"
    class="icon icon--open-in-browser"
  >
    <path
      d="M37.386,4H7.3A4.3,4.3,0,0,0,3,8.3V34.087a4.3,4.3,0,0,0,4.3,4.3h8.6v-4.3H7.3V12.6H37.386V34.087h-8.6v4.3h8.6a4.311,4.311,0,0,0,4.3-4.3V8.3A4.3,4.3,0,0,0,37.386,4ZM22.342,16.895l-8.6,8.6h6.447V38.386h4.3V25.491h6.447Z"
      transform="translate(3.447 4.596)"
    />
  </svg>
</template>

<script>
  export default {
    name: 'OpenInBrowser',
  };
</script>